//import './App.css';

import Block from "../Block/Block";
import Footer from "../Footer/Footer";
import Header from "../Header/Header";
import BlockContent from "../Block/BlockContent";
import BlockTitle from "../Block/BlockTitle";
import BlockSubtitle from "../Block/BlockSubtitle";
import BlockText from "../Block/BlockText";
import BlockImage from "../Block/BlockImage";
import BlockButton from "../Block/BlockButton";

import { useNavigate } from 'react-router-dom';

function Home() {
  const navigate = useNavigate();
  return (
      <div>
        <Header/>
        
        <div style={{backgroundImage:'url("/Home/pointwave.webp")', 
                    height:"200px",
                    width: "100%",
                    backgroundSize: "100% 100%",
                    backgroundPosition: "bottom"}}>
        </div>

        <Block colorTheme="light" gridTemplateColumns="600px 600px">
          <BlockContent>
            <BlockTitle>Herbert M. Potechius</BlockTitle>
            <BlockSubtitle>Computer Scientist</BlockSubtitle>
          </BlockContent>
          <BlockContent>
            <BlockText>This website presents my professional journey and personal profile. It showcases the projects I've contributed to, the datasets I've created, the publications I've authored, as well as aspects of my personal background and interests. To learn more about my educational and professional background, explore the 'Profile' section. For an overview of my latest projects, simply scroll down.</BlockText>
          </BlockContent>
        </Block>



          <Block colorTheme="dark" gridTemplateColumns="600px 600px">
            <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/project_cards/Homepage_FAUstairs_card.webp'}/>
            </BlockContent>
            <BlockContent>
              <BlockTitle>FAUstairs</BlockTitle>
              <BlockText>The FAUstairs project is funded by the Foundation for Innovation in Higher Education (German: Stiftung Innovation in der Hochschullehre) and is carried out at the Friedrich-Alexander University Erlangen-Nürnberg (FAU). The primary objective of the project is to improve student success by developing innovative formative assessment strategies and modern digital learning environments. It seeks to integrate web-based technologies, learning analytics, and AI-supported educational tools into higher education, creating a flexible and accessible platform that enhances teaching, learning, and assessment.</BlockText>
              <BlockButton onClick={() => navigate('/Projects/FundedProjects/FAUstairs')}>Learn more</BlockButton>
            </BlockContent>
          </Block>


        {window.innerWidth >= 1200 ?
          <Block colorTheme="light" gridTemplateColumns="600px 600px">
            <BlockContent>
              <BlockTitle>MoVeKI2EAH</BlockTitle>
              <BlockText>The MoveKI2EAH project was sponsored by the Federal Ministry of Research, Technology and Space (German: <i>Bundesministerium für Forschung, Technologie und Raumfahrt</i> - BMFTR) and operated as an internal initiative at the <b>University of Applied Sciences Jena</b>. The primary objective of this project was to modernize the teaching of artificial intelligence subjects at the university level. It seeked to create a series of teaching units that address easily comprehensible topics in AI. These units can be seamlessly integrated into broader teaching modules as required.</BlockText>
              <BlockButton onClick={() => navigate('/Projects/FundedProjects/MoVeKI2EAH')}>Learn more</BlockButton>
            </BlockContent>
            <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/project_cards/moveki2eah_logo2.webp'}/>
            </BlockContent>
          </Block>
          :
          <Block colorTheme="light" gridTemplateColumns="600px 600px">
            <BlockContent>
              <BlockImage src={process.env.PUBLIC_URL + '/images/project_cards/moveki2eah_logo2.webp'}/>
            </BlockContent>
            <BlockContent>
              <BlockTitle>MoVeKI2EAH</BlockTitle>
              <BlockText>The MoveKI2EAH project was sponsored by the Federal Ministry of Research, Technology and Space (German: <i>Bundesministerium für Forschung, Technologie und Raumfahrt</i> - BMFTR) and operated as an internal initiative at the <b>University of Applied Sciences Jena</b>. The primary objective of this project was to modernize the teaching of artificial intelligence subjects at the university level. It seeked to create a series of teaching units that address easily comprehensible topics in AI. These units can be seamlessly integrated into broader teaching modules as required.</BlockText>
              <BlockButton onClick={() => navigate('/Projects/FundedProjects/MoVeKI2EAH')}>Learn more</BlockButton>
            </BlockContent>
          </Block>
        }

        <Block colorTheme="dark" gridTemplateColumns="600px 600px">
          <BlockContent>
            <BlockImage src={process.env.PUBLIC_URL + '/images/project_cards/drone_search2.webp'}/>
          </BlockContent>
          <BlockContent>
            <BlockTitle>SmartSense&Rescue</BlockTitle>
            <BlockText>This project was funded by the Federal Ministry for Economic Affairs and Energy (BMWi) and was a collaboration between the Technical University Berlin, the crisis prevention company Eurocommand and the emergency service of Cham (district in Bavaria). The main goal is the development of a software capable of detecting and tracking missing persons with optical and thermal cameras from drone perspective in order to support the rescue workers during their missions.</BlockText>
            <BlockButton onClick={() => navigate('/Projects/FundedProjects/SSR')}>Learn more</BlockButton>
          </BlockContent>
        </Block>

        <Footer/>
      </div>
  );
}

export default Home;
